import { render, staticRenderFns } from "./OpisBlockShow.vue?vue&type=template&id=5030e1dc&"
import script from "./OpisBlockShow.vue?vue&type=script&lang=js&"
export * from "./OpisBlockShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports